import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

import Vue from 'vue'

const routes = new Router({
  common,
  home,
  aboutUs,
});

jQuery(document).ready(() => routes.loadEvents());
